import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'fileSize' })
export class FileSizePipe implements PipeTransform {
  transform(bytes: number): string {
    if (isNaN(bytes) || !isFinite(bytes)) return '-';
    const units = ['bytes', 'KB', 'MB', 'GB', 'TB', 'PB'];
    const size = Math.floor(Math.log(bytes) / Math.log(1024));
    return (bytes / Math.pow(1024, Math.floor(size))).toFixed(1) + ' ' + units[size];
  }
}
